import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector, runInInjectionContext } from '@angular/core';

import { Auth, authState, getIdToken } from '@angular/fire/auth';
import { EMPTY, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	private auth = inject(Auth);

	private injector = inject(Injector);

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		if (request.url.includes('skipAuth=true')) {
			return next.handle(request);
		}

		return authState(this.auth).pipe(
			switchMap((user) => runInInjectionContext(this.injector, () => user ? getIdToken(user) : EMPTY)),
			switchMap((token) => {
				if (token) {
					request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
					return next.handle(request);
				}
				return EMPTY;
			})
		);
	}
}
